// Carga de librerías JS se espera que esté en theme.liquid o directamente enlazadas en este archivo si fueran externas
// Asegúrate de que GSAP, ScrollTrigger y Canvas Confetti estén cargados antes de que este script se ejecute.

document.addEventListener("DOMContentLoaded", function() {
    // === Funcionalidad para animaciones GSAP ===
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        
        // Animaciones para elementos con la clase .gsap-reveal
        gsap.utils.toArray('.gsap-reveal').forEach(elem => {
            gsap.fromTo(elem,
                { y: 50, autoAlpha: 0 }, // autoAlpha maneja tanto opacity como visibility
                { 
                    y: 0, 
                    autoAlpha: 1, 
                    duration: 1.2, 
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: elem,
                        start: 'top 85%', // Empieza la animación cuando el 85% del elemento está visible
                        toggleActions: 'play none none resume', // Play al entrar, nada al salir
                        once: true // La animación solo se reproduce una vez
                    }
                }
            );
        });

        // Lógica para resaltar "descubrir la excelencia." en el titular del Hero
        // Esto asume que el titular del Hero siempre tendrá este texto para resaltar
        const heroHeadline = document.querySelector('.hero-section .e-headline');
        if (heroHeadline) {
            const headlineText = heroHeadline.innerHTML;
            const highlightedText = 'descubrir la excelencia.';
            if (headlineText.includes(highlightedText)) {
                heroHeadline.innerHTML = headlineText.replace(
                    highlightedText,
                    `<span class="highlight-gold">${highlightedText}</span>`
                );
            }
        }

    } else {
        console.warn("GSAP o ScrollTrigger no están cargados. Las animaciones 'gsap-reveal' no funcionarán.");
    }

    // === Funcionalidad para los botones CTA ===
    function handleCtaClick(e) {
        e.preventDefault();
        
        // Intenta desplazar a la parte superior del header, si existe
        const mainHeader = document.querySelector('header');
        if (mainHeader) {
            mainHeader.scrollIntoView({ behavior: 'smooth' });
        } else {
            // Si no hay header, simplemente ve al top de la página
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // Efecto confetti solo si canvas-confetti está disponible y es el CTA del hero
        if (this.classList.contains('hero-cta') && typeof confetti !== 'undefined') {
            confetti({
                particleCount: 150,
                spread: 90,
                origin: { y: 0.6 },
                colors: ['#D6AE53', '#FAFDE2', '#5D6245']
            });
        }
    }

    // Adjunta el event listener solo a los CTAs dentro de la sección Hero
    document.querySelectorAll('.hero-section .hero-cta').forEach(cta => {
        cta.addEventListener('click', handleCtaClick);
    });
    
    // === Barra de CTA Inferior (Sticky CTA Bar) ===
    // Asegúrate de que esta barra exista en tu HTML (e.g., en theme.liquid o como otra sección)
    // He re-integrado la lógica para la barra pegajosa.
    const stickyBar = document.querySelector('.sticky-cta-bar');
    if (stickyBar && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        let lastScroll = 0;
        ScrollTrigger.create({
            trigger: 'body',
            start: "top top", // Empieza a observar desde el top de la página
            end: "bottom bottom", // Termina de observar al final de la página
            onUpdate: (self) => {
                const currentScroll = self.scroll();
                // Muestra la barra si se baja lo suficiente y el scroll es descendente
                if (currentScroll > lastScroll && currentScroll > window.innerHeight * 0.5) {
                    gsap.to(stickyBar, { y: '0%', autoAlpha: 1, duration: 0.4, ease: 'power2.out' });
                } 
                // Oculta la barra si se sube
                else if (currentScroll < lastScroll) {
                    gsap.to(stickyBar, { y: '100%', autoAlpha: 0, duration: 0.4, ease: 'power2.in' });
                }
                lastScroll = currentScroll;
            }
        });

        // Asegúrate de que el botón de la barra pegajosa también tenga el click handler
        const stickyCtaButton = stickyBar.querySelector('.sticky-cta-button');
        if (stickyCtaButton) {
            stickyCtaButton.addEventListener('click', handleCtaClick);
        }

    } else if (stickyBar) {
      console.warn("GSAP o ScrollTrigger no están cargados. La sticky CTA bar no tendrá animación.");
    }
});